<template>
  <div class="fff p10 edit">
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="pay-mains">
          <!-- <p class="order-title-boxs"><span class="blueBlock"></span><i>订单信息</i></p> -->
          <div class="totals-box plr24 mt30">
            <div class="flex-row mb30">
              <div class="itemName">审核状态</div>
              <div class="itemNum" :class="form.auditStatus == 'refuse' ? 'moneys':form.auditStatus == 'pass' ? 'jishi' : ''">{{ form.auditStatusCn }}</div>
            </div>
			<div class="flex-row mb30">
			  <div class="itemName">审核人</div>
			  <div class="itemNum">{{ form.auditStaffName }}</div>
			</div>
			<div class="flex-row mb30">
			  <div class="itemName">审核时间</div>
			  <div class="itemNum">{{ formatDate(form.auditTime) }}</div>
			</div>
            <div class="flex-row mb30">
              <div class="itemName">档案编号</div>
              <div class="itemNum">{{ form.docNo }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">修护时间</div>
              <div class="itemNum">{{ formatDate(form.repairTime) }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">修护技师</div>
              <div class="itemNum">{{ form.staffName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">登记照片</div>
              <div class="img-list">
                <el-image
                  class="img"
                  v-for="(i,j) in form.imgUrlList"
                  :key="j"
                  :src="i"
                  title="点击放大图片"
                  :preview-src-list="previewList"
                  @click="handPreview(i)"
                ></el-image>
              </div>
            </div>
            <div class="flex-row mb30" v-if="this.form.auditStatus == 'refuse'">
              <div class="itemName">拒绝原因</div>
              <div class="itemNum">{{ form.auditRemark }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">备注</div>
              <div class="itemNum">{{ form.remark }}</div>
            </div>
            <div class="flex-end pt16 borderT">
              <p class="jishi cur" @click="handleChange(form)">查看详情 <i class="el-icon-arrow-right"></i></p>
            </div>
          </div>
       
        </div>
        <div class="drawer-footer pb10 pr24">
          <div class="btns" v-perm="{key:'repairAudit', value:'repairAudit:audit'}">
            <!-- <el-button @click="back">取消</el-button> -->
            <!-- type="danger" -->
            <!-- type=btn-dandu -->
            <el-button
              v-if="form.auditFlag=='yes'"
              class="small-btn"
              @click="saveAudit('refuse')"
            >审核拒绝</el-button>
            <el-button
              v-if="form.auditFlag=='yes'"
              class="small-btn"
              type="primary"
              @click="saveAudit('pass')"
            >审核通过</el-button>
          </div>
        </div>
      </div>
    </drawer>
    <el-dialog
      :title="title"
      :visible.sync="centerDialogVisible"
      width="30%"
      style="margin-top: 20vh;"
      center>
      <el-input v-model="audit.auditRemark" v-if="this.audit.auditStatus == 'refuse'" maxlength="20" placeholder="请输入拒绝原因"></el-input>
      <span v-else style="color: red;text-align: center;display: inline-block;width: 100%;">确定同意吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="calcel">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
    <auditSet ref="auditForm" @change="auditChange"></auditSet>
    <handle ref="editForm"></handle>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
import handle from "../../collectMoney/paperRepair/handle";
import auditSet from "./audit-set";
export default {
  data() {
    return {
      addEditTitle: "档案审核",
      addEditShow: false,
      form: {},
      centerDialogVisible: false,
      audit: {
        id: "",
        auditStatus: "pass",
        auditRemark: ""
      },
      title: '确定拒绝吗？',
      previewList: []
    };
  },
  mixins: [minxin],
  created() {
    this.init();
  },
  components: { auditSet, drawer , handle},
  methods: {
    back() {
      this.addEditShow = false;
    },
    init() {
      this.$on("set", function(row) {
        Object.assign(this.$data, this.$options.data());
        this.form = {};
        this.addEditShow = true;
        this.$api
          .get(this.$url.repairRecord.get, {
            id: row.id
          })
          .then(res => {
            if (res) {
              this.form = res;
              this.audit.id = this.form.id;
              this.form.validEndTime = this.formatDate(this.form.validEndTime);
              for (let i in this.form.recordList) {
                this.form.recordList[i].repairTime = this.formatDate(
                  this.form.recordList[i].repairTime
                );
              }
            }
          })
          .catch(error => {});
      });
    },
    handPreview (url) {
      let imgUrl = []
      this.previewList = []
      if (url.indexOf("?") > -1) {
        let arr = url.split("?")
        imgUrl.push(arr[0])
      } else {
        imgUrl.push(url)
      }
      this.previewList = imgUrl
      console.log(this.previewList);
    },
    handleChangeDrawer() {
      this.addEditShow = false;
      this.$emit("change", false);
    },
    detailSetPage(row) {
      this.$refs["auditForm"].$emit("set", row);
    },
    saveAudit(typeVal) {
      this.audit.auditStatus = typeVal;
      if (this.audit.auditStatus == "refuse") {
        this.centerDialogVisible = true
      } else {
        this.title = '提示'
        this.audit.auditRemark = "";
        this.centerDialogVisible = true
      }
    },
    submit () {
      if (this.audit.auditStatus == "refuse" && this.audit.auditRemark == "") {
        return this.$message.error("请输入拒绝原因")
      }
      this.$api.post(this.$url.repairRecord.audit, this.audit).then(res => {
        if (res) {
          this.addEditShow = false;
          this.centerDialogVisible = false;
          this.$message.success("操作成功");
          this.$emit("change", true);
        }
      });
    },
    calcel () {
      this.audit.auditRemark = ""
      this.centerDialogVisible = false
    },
    auditChange(value) {
      if (value) {
        this.init();
      }
    },
    handleChange (row) {
      let obj = JSON.parse(JSON.stringify(row))
      obj.id = obj.repairDocumentId
      obj.audit = 1
      this.$refs["editForm"].$emit("set", obj);
    }
  }
};
</script>


<style scoped lang="less">
@import "../../../assets/css/edit.less";
.pay-mains {
  .img {
    border-radius: 5px;
    margin: 10px 10px 0 0;
    width: 80px;
    height: 80px;
  }
}
</style>